<template>
    <vue-loading
        :active.sync="isVisibleProp ? isVisibleProp : showLoader"
        :is-full-page="true"
        :opacity="0.7"
        color="#17d4bf"
        background-color="#000"
    >
        <img :src="`${pathApp}/images/loader_def.gif`" class="nicolaus-loader">
        <img :src="`${pathApp}/images/loader_valtur.gif`" class="valtur-loader">
    </vue-loading>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    name: "Loading",
    components: {
			'vue-loading': Loading
    },
    data: () => {
			return {
				pathApp: window.appUrl,
				showLoader: false,
			}
    },
		props: {
			isVisibleProp: {
				type: Boolean,
				default: false
			}
		},
    created() {},
    mounted() {
			this.$bus.$on('loading', (value) => {
				if(this.showLoader !== value) {
					this.setVisibilityIconExtras(!value)
					this.showLoader = value;
				}
			})
    },
};
</script>
